export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const tuple = <T extends string[]>(...args: T) => args;
export const tupleNum = <T extends number[]>(...args: T) => args;

const Is = (x?: any) => x != null;

Is.undef = (x?: any | null) => "undefined" === typeof x;
Is.func = (x?: any | null) => "function" === typeof x;
Is.bool = (x?: any | null) => "boolean" === typeof x;
Is.str = (x?: any | null) => "string" === typeof x;
Is.obj = (x?: any | null) => "object" === typeof x && !!x;
Is.num = (x?: any | null) => x === +x;
Is.arr = (x?: any | null) => Array.isArray(x);
Is.Obj = (x?: any | null) => toString.call(x) === "[object Object]";
Is.err = (x?: any | null) => x instanceof Error;
Is.own = (a: object, b: any) => Is.obj(a) && a.hasOwnProperty.call(a, b);
Is.range = (a?: any, b?: any, c?: any) => a <= b && b <= c;
Is.empty = (x?: any | null) => {
  for (let i in x) return false;
  return !x || Is.obj(x);
};

Is.equal = (a: any, b: any): boolean => {
  const type_a = toString.call(a);
  const type_b = toString.call(b);

  if (type_a !== type_b) return false;

  switch (type_a) {
    case "[object Array]": {
      if (a.length !== b.length) return false;
      // @ts-ignore
      return a.every((x, i) => Is.equal(x, b[ i ]));
    }
    case "[object Object]": {
      const values_a = Object.values(a);
      const values_b = Object.values(b);
      if (values_a.length !== values_b.length) return false;
      return values_a.every((x, i) => Is.equal(x, values_b[ i ]));
    }
    case "[object Date]":
      return +a === +b;
    default:
      return a === b;
  }
};

Is.deepEqual = Is.equal;

// @ts-ignore
Is.get = (o, path = "", def) => Is.obj(o) ? path.split(".").every(x => Is(o = o[ x ])) ? o : def : def;

export function classNames(...args: any[]) {
  const classes = new Set<string>();

  for (let arg of args) {
    if (arg) {
      if (Is.str(arg)) {
        classes.add(arg);
      } else if (Is.arr(arg)) {
        arg.forEach(classes.add, classes);
      } else if (Is.obj(arg)) {
        for (let name in arg) {
          Is.own(arg, name) && arg[ name ] && classes.add(name);
        }
      }
    }
  }
  return Array.from(classes).join(" ");
}


